
import {useEffect, useRef} from "react";
import myCharacterImg from "../../assets/my-character.jpg";
import teamworkImg from "../../assets/slide3_3_mini.png";
import myCartoonImg from "../../assets/slide_1_1_good.png";
import {BTN_KEY} from "../../util/util";

const SelfIntroduction2 = ({changeBtnKey, allMode = false}) => {
    const selfInfoInfo = {
        imagePath:'',
        content:'<div class="selfIntro-main-content"><h2><p>[<span class="fade-item delay-3">팀원</span>] 그리고 ' +
            '[<span class="fade-item delay-7">코드</span>]에 </p>' +
            ' <p class="center-align">100퍼센트 <span class="font-purple-highlight">융화</span>되는 개발자 </p>' +
            '<p class="right-align">[<span class="fade-item delay-10">이준복</span>] 입니다.</p></h2>' +
            '</div>' +
            '<div class="selfIntro-sub-content">' +
            '<p class="lead">▪️맡은 업무를 끝까지 책임감 있게 완수하는 데 확고한 자신감을 가지고 있습니다.</p>' +
            '<p class="lead">▪️팀원과의 소통과 협력을 중요하게 생각하며, ' +
            '누구보다 지지않을 열정을 가지고 있습니다.</p>' +
            '<p class="lead">▪️체계적으로 분석하는 것을 좋아하며, 적극적인 소통을 통한 효율적인 업무를 지향합니다.</p>' +
            '<p class="lead"> 🔥 매 순간 성장하고 발전하는 개발자 🔥</p>' +
            '<p class="lead"> 상사에게는 신뢰받고 팀원에게는 지지를 받으며,' +
            ' 후배에게는 훌륭한 사수가 되는 개발자로 미래를 나아가겠습니다.</p>' +
            '</div>',
    }

    const activeTarget = 'choice-summary-1';
    const focusRef = useRef();
    useEffect(() => {
        if (allMode) return;
        document.querySelector(`#${activeTarget}`)?.classList?.add('border-primary');
        focusRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    },[]);

    return (
        <>
            <hr className='featurette-divider'/>
            {!allMode && (
                <div className='right-align'>
                    <h4>
                        <div>
                            <div className="fold-button mt-2 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                     fill="currentColor"
                                     className="bi bi-x-circle custom-fold-top" viewBox="0 0 16 16"
                                     onClick={() => {
                                         changeBtnKey(BTN_KEY.DEFAUlT);
                                     }}>
                                    <path
                                        d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                    <path
                                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"></path>
                                </svg>
                            </div>
                        </div>
                    </h4>
                </div>
            )}
            <div className="container marketing" ref={focusRef}>
                <div className="row justify-content-center text-center">
                    <div className="col-lg-6">
                        <img
                            src={myCharacterImg}
                            alt="profile"
                            className="rounded-circle intro-round-margin"
                            style={{width: "160px", height: "160px", objectFit: "cover"}}
                        />
                        <h3 className="font-highlight fw-bolder fade-item delay-2">팀원 그리고 코드에</h3>
                        <p>맡은 업무를 끝까지 책임감 있게 완수하는 데 확고한 자신감을 가지고 있습니다.</p>
                        <p className='fw-bold'>팀원과의 협력을 중요하게 생각합니다.</p>
                        {/*<p><a className="btn btn-secondary" href="#"></a></p>*/}
                    </div>
                    <div className="col-lg-6">
                        <img
                            src={teamworkImg}
                            alt="profile"
                            className="rounded-circle intro-round-margin"
                            style={{width: "160px", height: "160px", objectFit: "cover"}}
                        />
                        <h3 className="font-highlight fw-bolder fade-item delay-4">100% 융화되는 개발자</h3>
                        <p>체계적으로 분석하는 것을 좋아하며, 적극적인 소통을 통한 효율적인 업무를 지향합니다.</p>
                        <p className='fw-bold'>누구보다 지지않을 열정을 가지고 있습니다.</p>
                    </div>

                    <div className="col-lg-6">
                        <img
                            src={myCartoonImg}
                            alt="profile"
                            className="rounded-circle intro-round-margin"
                            style={{width: "160px", height: "160px", objectFit: "cover"}}
                        />
                        {/*<h3 className="fw-normal"></h3>*/}
                        <h3 className="font-highlight fw-bolder fade-item delay-6">이준복입니다.</h3>
                        <p className='fw-bold'>🔥 매 순간 성장하고 발전하는 개발자 🔥</p>
                        <p>상사에게는 신뢰받고 팀원에게는 지지를 받으며, 후배에게는 훌륭한 사수가 되는 개발자로 미래를 나아가겠습니다.</p>
                        {/*<p><a className="btn btn-secondary" href="#"></a></p>*/}
                    </div>
                </div>
            </div>
        </>
    )
}


export default SelfIntroduction2;